import { Obj } from "@kizmann/pico-js";

export const TokenFormConfig = {};

Obj.set(TokenFormConfig, 'NFormItem:client', {
    props: {
        label: '@Client',
        prop: 'client',
        rules: ['required']
    },
});

Obj.set(TokenFormConfig, 'NFormItem:client.content.NInput', {
    binds: {
        modelValue: {
            value: '$model.client', fallback: ''
        }
    },
    props: {
        placeholder: '@Client name'
    }
});

Obj.set(TokenFormConfig, 'NFormItem:is_active', {
    props: {
        label: '@Active',
        prop: 'is_active',
    },
});

Obj.set(TokenFormConfig, 'NFormItem:is_active.content.NSwitch', {
    binds: {
        modelValue: {
            value: '$model.is_active', fallback: 1
        }
    },
    props: {
        onValue: 1,
        offValue: 0
    },
    content: '@Token is active',
});

Obj.set(TokenFormConfig, 'NFormItem:hash', {
    props: {
        label: '@Hash',
        prop: 'hash',
        rules: ['minlength:10']
    },
});

Obj.set(TokenFormConfig, 'NFormItem:hash.content.NInput', {
    binds: {
        modelValue: {
            value: '$model.hash', fallback: ''
        }
    },
    props: {
        placeholder: '@Autogenerate if empty'
    }
});

export default TokenFormConfig;